// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"7db260bb","585":"db406b2f"}[chunkId] + ".chunk.css";
};